<template>
  <div class="footer-tabbar">
    <van-tabbar active-color="#4895f7" v-model="active">
      <van-tabbar-item
        v-if="showReservation"
        name="GameReservationC1"
        :class="{ 'animate__animated animate__bounceIn': active == 'GameReservationC1' }"
        icon="friends-o"
        :to="{ name: 'GameReservationC1' }"
      >预约有礼</van-tabbar-item
      >
      <van-tabbar-item
        name="WelfareCenter"
        :class="{ 'animate__animated animate__bounceIn': active == 'WelfareCenter' }"
        icon="gift"
        :to="{ name: 'WelfareCenter' }"
        >礼包</van-tabbar-item
      >
      <van-tabbar-item
        name="GameRanking"
        :class="{ 'animate__animated animate__bounceIn': active == 'GameRanking' }"
        icon="bar-chart-o"
        :to="{ name: 'GameRanking' }"
      >数据</van-tabbar-item
      >
      <van-tabbar-item icon="user-o" name="UserIndex" :class="{ 'animate__animated animate__bounceIn': active == 'UserIndex' }" :to="{ name: 'UserIndex' }"
        >我的</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>
<script>
export default {
  name: 'FooterTabbar',
}
</script>
<script setup>
import { Icon, Tabbar, TabbarItem } from 'vant'
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import config, { isReservationVisible } from '@/config'
import { openOnlineService } from '@/utils/common'

const THIRTY_MINUTES = 30 * 60 * 1000

const store = useStore()
const VanIcon = Icon
const VanTabbar = Tabbar
const VanTabbarItem = TabbarItem

const active = computed({
  get() {
    return store.state.settings.footTabbarActive
  },
  set(val) {
    return val
  },
})

const showReservation = ref(false)
let timer = null

function updateVisibility() {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }

  const visible = isReservationVisible(config.reservation.startUtc, config.reservation.endUtc)
  showReservation.value = visible

  const start = new Date(config.reservation.startUtc).getTime()
  const end = new Date(config.reservation.endUtc).getTime()
  const now = Date.now()

  let nextBoundary = null
  if (!visible && now < start) {
    nextBoundary = start
  } else if (visible && now < end) {
    nextBoundary = end
  }

  if (nextBoundary !== null) {
    const delta = nextBoundary - now
    if (delta > 0 && delta < THIRTY_MINUTES) {
      timer = setTimeout(updateVisibility, delta)
    }
  }
}

onMounted(updateVisibility)
onUnmounted(() => {
  if (timer) {
    clearTimeout(timer)
    timer = null
  }
})
</script>
<style lang="scss" scoped></style>
